import { Inbox, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface EmptyStateProps {
    icon?: LucideIcon
    title: string
    /**
     * Say what would put something here, not just that nothing is here. An empty
     * state is the one moment an operator is guaranteed to read the interface.
     */
    description?: ReactNode
    action?: ReactNode
    className?: string
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, className }: EmptyStateProps) {
    return (
        <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-16 text-center', className)}>
            <div
                aria-hidden
                className="flex size-10 items-center justify-center rounded-lg border border-border bg-surface-raised text-muted-foreground">
                <Icon className="size-5" />
            </div>
            <p className="text-sm font-medium text-foreground">{title}</p>
            {description && <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>}
            {action && <div className="mt-1">{action}</div>}
        </div>
    )
}
